import { stringValidator } from '#validation/common/validators';
export const subscriptionTypeValidator = stringValidator({
    requiredError: 'filespace.subscriptionType.required',
});
